import { render, staticRenderFns } from "./CreateMianLiao.vue?vue&type=template&id=4931848e&scoped=true&"
import script from "./CreateMianLiao.vue?vue&type=script&lang=js&"
export * from "./CreateMianLiao.vue?vue&type=script&lang=js&"
import style0 from "./CreateMianLiao.vue?vue&type=style&index=0&id=4931848e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4931848e",
  null
  
)

export default component.exports